module.exports = __webpack_public_path__ + "media/images/bg-plant-left-af37aa1fb7b6c1a9840017d7c32a1786.png";